import {changeLangTitle, determineLanguage, displayCard, handleClickOnSeeMoreButton, loaderAnimation, removeLoaderAnimation, setActiveTab} from "../common/util";
import {questionCategory} from "../enum/faq";
import {NUMBER_OF_CARDS_ON_LOAD} from '../constants/constants';
import {redirectIfConflict} from "../common/tink";
import {Question} from "../interface/interfaces";
import {getTraduction, traductionEnum} from "../common/traduction";
import {pushEventFaq, pushEventFaqDetail, pushEventLightbox} from "../common/cybermetrie.js";

require("@fancyapps/fancybox");
require("slick-carousel/slick/slick");
require("jquery");
require("jquery-ui");

const CARD_CLASS = '.faq-tile';
let $gridInProgress = $('#faq-grid');
let $containerWithLoadingAnimation = $('.page-container');
let currentQuestions = NUMBER_OF_CARDS_ON_LOAD;
let lang: string = determineLanguage();
let seeMoreQuestionsClicked = false;
let $modal = $('#faq-modal');

$(() => {
    bindTabEvent();
    bindEventsOnQuestion();
    let $seeMoreInProgress = $('#see-more');
    displayCard($('#faq-grid'), NUMBER_OF_CARDS_ON_LOAD, $seeMoreInProgress, true);
    buildJsonLd();
    pushEventFaq(questionCategory.ALL)
})

function buildJsonLd() {
    // @ts-ignore
    if (questionsJsonLd) {
        let el = document.createElement('script');
        el.type = 'application/ld+json';
        // @ts-ignore
        el.text = questionsJsonLd;
        $('head').append(el);
    }
}

function bindTabEvent() {
    // Iterate on tabs for questions
    Object.entries(questionCategory).map(([enumKey, enumValue]) => {
        let prefix = 'category_';
        let idSelect = '#' + prefix + enumKey;

        // @ts-ignore
        const url = questionUrl + '/' + enumValue;

        $(idSelect).on('click', function () {
            setActiveTab($(this), '#faq-tab');

            loaderAnimation($containerWithLoadingAnimation, false);

            $.ajax({
                url: url,
                type: 'GET',
                headers: {
                    'Accept-Language': lang
                },
                success: function (data) {
                    replaceCards(data);
                    bindEventsOnQuestion();
                    removeLoaderAnimation($containerWithLoadingAnimation);
                    pushEventFaq(enumValue)
                },
                error: function (jqXHR) {
                    removeLoaderAnimation($containerWithLoadingAnimation);
                    redirectIfConflict(jqXHR);
                }
            });
        });
    })
}

function replaceCards(data: string) {
    // Find and replace the html for the loaded fragment
    let $sectionToPutHtmlIn = $('.faq-layout');
    $sectionToPutHtmlIn.replaceWith(data);

    // Reset the button state to see more questions
    seeMoreQuestionsClicked = false;
    let $questionsContainer = $('#faq-grid');

    // Display the right amount of tiles in the grid and return the amount of tile not hidden
    let $seeMoreInProgress = $('#see-more');
    currentQuestions = displayCard($questionsContainer, NUMBER_OF_CARDS_ON_LOAD, $seeMoreInProgress, true);
}

function bindEventsOnQuestion() {
    // Setting the event on question click
    let $card = $('.faq-tile');
    $card.on('click', function (event) {
        // @ts-ignore
        fillModal($(this), questions);

    }).on('keyup', function (event) {
        if (event.key === 'Enter') {
            event?.preventDefault();
        }
    }).on('keydown', function (event) {
        // This prevents the keydown to be called
        if (event.key === 'Enter') {
            // @ts-ignore
            fillModal($(this), questions);
        }
    });
    seeMoreQuestionsClicked = false;

    // Setting the event on see more button click and enter
    let $seeMoreActiveButton = $('#see-more');
    $seeMoreActiveButton.on('click', function () {
        actionOnSeeMoreButton($(this));
    });

    $seeMoreActiveButton.on('keyup', function (event) {
        if (event.key === 'Enter') {
            actionOnSeeMoreButton($(this));
            event?.stopPropagation();
        }
    }).on('keydown', function (event) {
        // This prevents the keydown to be called
        if (event.key === 'Enter') {
            event?.preventDefault();
        }
    });
}

function actionOnSeeMoreButton($element: any) {

    let $currentQuestionsContainer = $('#faq-grid');
    let isCurrentSeeMoreClicked = seeMoreQuestionsClicked;

    // Display the right amount of tiles in the grid and return the amount of tiles not hidden
    currentQuestions = handleClickOnSeeMoreButton($element, $currentQuestionsContainer, isCurrentSeeMoreClicked);
    $element.children().first().text(getTraduction(traductionEnum.SEE_MORE_QUESTION_BUTTON_CLICKED));

    // Button has been clicked
    seeMoreQuestionsClicked = true;
}

function fillModal($element: JQuery<HTMLElement>, questionList: Question[]) {
    let id = Number($element.attr("data-cId"));

    let clickedQuestion = getQuestion(questionList, id);

    // Should not happen
    if (!clickedQuestion) return;

    // Title
    let modalQuestionLine1 = $modal.find(".description > h6");
    modalQuestionLine1.text(clickedQuestion.category);

    let modalQuestionLine2 = $modal.find(".description > h4");
    modalQuestionLine2.text(clickedQuestion.question);

    let $modalContentSection = $modal.find('.content');
    $modalContentSection.empty().append(clickedQuestion.answer);

    // Opening the modal
    $.fancybox.open({
        src: '#faq-modal',
        type: 'inline'
    }, {
        autoFocus: false,
        touch: false,

        beforeShow: function () {
            $("body").css({'overflow-y': 'hidden'});
        },
        afterShow(instance: FancyBoxInstance, current: FancyBoxSlide) {
            changeLangTitle()
        },
        afterClose: function () {
            $("body").css({'overflow-y': 'visible'});
            $($element).focus()
        }
    });
    pushEventLightbox('faq ' + clickedQuestion.question);
    pushEventFaqDetail(clickedQuestion.category, clickedQuestion.question)

}

function getQuestion(questionList: Question[], id: number): Question | undefined {
    return questionList.find((item) => item.id === id);
}
